<template>
  <div class="image-viewer">
    <el-button size="small" type="text" @click="onPreview">{{
      btnText
    }}</el-button>
    <el-image
      v-show="false"
      ref="preview"
      :preview-src-list="[url]"
      :src="url"
      class="hideImgDiv"
    ></el-image>
  </div>
</template>

<script>
export default {
  name: "image-viewer",
  props: {
    btnText: {
      type: String,
      default: "预览",
    },
    url: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onPreview() {
      //调用image组件中的大图浏览图片方法
      this.$refs.preview.clickHandler();
    },
  },
};
</script>

<style lang="scss" scoped>
.hideImgDiv {
  /deep/ .el-image__inner {
    display: none;
  }
}
</style>
